/* eslint-disable jsx-a11y/anchor-is-valid */
import React ,{useState,useEffect} from "react";
import { FaCopy,FaKey,FaCog, FaFile} from 'react-icons/fa';
import { TbRefresh } from 'react-icons/tb';
import {OverlayTrigger,Tooltip,Alert, Button} from "react-bootstrap";
import {Switch,FormControlLabel } from '@material-ui/core';
import { Link } from "react-router-dom";
import axios from "axios";
import { NODE_API_URL } from "../../../../env_config";
import { useHistory } from "react-router-dom";
import UpgradeSubscriptionPage from "../../apiv3/UpgradeSubscriptionPage";
export const ApiSettings = (props) => {
    // console.log(props.userinfo.id,"ApiSettingsApiSettings")
    const [value, setValue] = React.useState('');
    const [checked,setChecked] = React.useState();
    const [userdata,setUserData] = useState()
    const [credentailgen,setCredentialGen] = useState(false)
    const [showsubscription,setShowSubscription] = useState(false)
    useEffect(() => {
        if(props.userinfo){
            axios({
                method: "POST",
                url: `${NODE_API_URL}/TESTMODE/fetchIframeorAPISetting`,
                headers: { "Content-Type": "application/json" },
                data: {
                    "user_id":props.userinfo.id
                },
            }).then(supreq => {
                if(supreq && supreq.data && supreq.data.data){
                    // setFeedLoader(false)
                    setUserData(supreq.data.data)
                }
            })
        }
    },[value])
    function handleChange(event) {
        // console.log(event.target.checked,"CHECKEDDDDD")
        axios({
            method: "POST",
            url: NODE_API_URL + "/TESTMODE/onOffTestMode",
            headers: { "Content-Type": "application/json" },
            data: {
              "user_id":props.userinfo.id,
              "test_mode":event.target.checked?"ON":"OFF"
            },
          }).then((res) => {
            if (res && res.data && res.data.success) {
                setValue(res.data.msg)
                if(res.data.msg ==="Test mode Deactivated"){
                    setChecked(false)
                }else{
                    setChecked(true)
                }
                
            }
          });
    }
    const GenerateCredentails = () => {
        axios({
            method: "POST",
            url: NODE_API_URL + "/TESTMODE/mailForTestModeAPI",
            headers: { "Content-Type": "application/json" },
            data: {
              "user_id":props.userinfo.id
            },
          }).then((res) => {
            if (res && res.data) {
                setValue(res.data)
                setCredentialGen(true)
            }
          });
    }
    const GenerateLiveCredentails = () => {
        axios({
            method: "POST",
            url: NODE_API_URL + "/TESTMODE/generateNewToken",
            headers: { "Content-Type": "application/json" },
            data: {
              "user_id":props.userinfo.id
            },
          }).then((res) => {
            if (res && res.data) {
                setValue(res.data)
            }
          });
    }
    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        // console.log(result,"addDays")
        return result.toISOString();
      }
      function dateFormate(date){
        let formattedDate = "";
        if (date) {
            let dateObj = new Date(date);
            dateObj = new Date(dateObj.getTime() - (330 * 60 * 1000))
            const year = dateObj.getFullYear();
            const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
            const day = ('0' + dateObj.getDate()).slice(-2);
            const timeString = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
            formattedDate = `${year}-${month}-${day} ${timeString}`;
        }
        return formattedDate;
    }
    const getActive = (date) => {
        let newdate = new Date().getTime()
        let userdate = new Date(date).getTime()
        let status = `<span class="label label-success label-pill label-inline px-5">Active</span>`
        if(userdate <= newdate){
            status = `<span class="label label-danger label-pill label-inline px-5">InActive</span>`
        }
        return status
    }
    const history = useHistory()
    return (
        <>
        {showsubscription?<UpgradeSubscriptionPage {...props}/>:<div className="row">
            {userdata?<>
            <div className="col-12 mb-4 setting-title">{props.language.SETTING_API_SETTING}</div>
            <div className="col-md-12 text-right">
                <button className="btn font-weight-bold btn-square btn-primary px-10 mr-2" onClick={() => history.push({
                        pathname: "/diamondfeed"
                        // state: "apisetting",
                        // state: decompress(res.data.ProductDetails),
                    })}>Rule Page</button>
                    {/* <button className="btn font-weight-bold btn-square btn-primary px-10 mr-2" onClick={() => setShowSubscription(true)}>Upgrade Plan</button> */}
            </div>
            <div className="col-12">
                {checked === true?<Alert variant="success">
                Test mode Activated, Click on generate credentials to generate test-mode API key and test-mode login.
                </Alert>:""}
                {checked === false?<Alert variant="danger">
                    Test mode Deactivated
                </Alert>:""}
                {credentailgen?<Alert variant="success">
                Test API key generated, and login credentials has been sent to your registered email id.
                </Alert>:""}
            </div>
            <div className="col-12 mt-5 mb-4 font-weight-bold"> <FaKey className="mr-2" /> {props.language.SETTING_API_KEYDETIAL} </div>
            <div className="col-12">
                <table className="table table-bordered">
                    <tr className="bg-gray-100">
                        <th className="text-center">{props.language.SETTING_API_CREATEDON}</th>
                        <th className="text-center">{props.language.SETTING_API_TYPE}</th>
                        <th className="text-center">{props.language.SETTING_API_KEY}</th>
                        <th className="text-center">{props.language.SETTING_API_STATUS}</th>
                        <th className="text-center">{props.language.SETTING_API_EXPIRY}</th>
                    </tr>
                    <tr>
                        <td className="text-center align-middle">{userdata.api_test_key?dateFormate(userdata.aptest_created_date):""}</td>
                        <td className="text-center align-middle">Test</td>
                        <td className="text-center align-middle">
                            {/* <button className="btn btn-primary btn-sm">Generate API Key</button> */}
                            {/* <button className="btn btn-primary btn-sm">Generate Credentials</button> */}
                           {userdata.api_test_mode === "ON"?<div>
                                {userdata.api_test_key?<>{userdata.api_test_key} <span className="ml-2 apiIcon">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip">
                                                Copy API
                                            </Tooltip>
                                        }
                                    >
                                        <FaCopy className="cursor-pointer"
                                        onClick={() => navigator.clipboard.writeText(userdata.api_test_key)}
                                        />
                                    </OverlayTrigger>
                                </span></>:<Button color="primary" onClick={() => GenerateCredentails()}>Generate Credentials</Button>}
                           </div>:""}
                        </td>
                        <td className="text-center align-middle">
                            {userdata.api_test_mode === "OFF"?<span class="label label-danger label-pill label-inline px-5">InActive</span>:userdata.api_test_key?userdata.api === 0?<span class="label label-danger label-pill label-inline px-5">Expired</span>:<div dangerouslySetInnerHTML={{__html:getActive(addDays(userdata.aptest_created_date,6))}}></div>:<span class="label label-danger label-pill label-inline px-5">InActive</span>}
                            {/* <span class="label label-success label-pill label-inline px-5">Active</span> */}
                            {/* <span class="label label-danger label-pill label-inline px-5">InActive</span> */}
                            {/* <span class="label label-danger label-pill label-inline px-5">Expired</span> */}
                        </td>
                        <td className="text-center align-middle">
                        {userdata.api_test_key?dateFormate(addDays(userdata.aptest_created_date,6)):""}
                        </td>
                    </tr>
                </table>
            </div>
            <div className="col-12 border-top mt-5 mb-4 font-weight-bold pt-3"> <FaFile className="mr-2"/> {props.language.SETTING_API_DOC} </div>
            <div className="col-12">
                {props.language.SETTING_API_MSG5}
            </div>
            <div className="col-12">
                {props.userinfo.v_customer === "1" ?
                    <Link to={{ pathname:'/api-documentation-vip' }}>{props.language.SETTING_API_MSG6}</Link>
                    :
                    <Link to={{ pathname:'/api-documentation' }}>{props.language.SETTING_API_MSG6}</Link>
                }
            </div>
            {userdata && userdata.api_plan?<div className="col-12 font-weight-bold">
                Your Subscription is Active with <strong>{userdata.api_plan}</strong> Plan.
            </div>:<div className="col-12 font-weight-bold text-danger">
                Please Contact with your sales person for Upgrading Plans.
            </div>}
            </>:""}
        </div>}
        </>
    );
};
